import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { getData, getDataById, getcountries } from '../../../services/admin/invoiceReceipt/invoiceReceiptServices';
import { Modal, Button, Form, Table } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../../components/Layout/Header';
import Footer from '../../../components/Layout/Footer';
import Sidebar from '../../../components/Layout/Sidebar';
import Spinner from '../../../components/Spinner';

 
const InvoiceReceiptGenerated = () => {
  const [dataList, setDataList] = useState([]);
  const [form, setForm] = useState({ 
    id  : '',
    bank_address  : '',
    bank_name  : '',
    beneficiarys_account_number  : '',
    beneficiarys_address  : '',
    beneficiarys_name  : '',
    billing_address  : '',
    billing_country  : '',
    billing_email  : '',
    billing_name  : '',
    billing_phone_no  : '',
    createdAt  : '',
    currency  : '',
    event_date  : '',
    event_title  : '',
    event_type  : '',
    in_branch_code  : '',
    in_iban_bic_code  : '',
    in_swift_code  : '',
    invoice_date  : '',
    invoice_id  : '',
    no_of_ticket  : '',
    payment_mode  : '',
    pdf_status  : '',
    reg_amount  : '',
    registration_type  : '',
    series  : '',
    sub_domain  : '',
    subject  : '',
    updatedAt  : '',
    us_ein_number  : '',
    us_iban_number  : '',
    us_swift_bic_code  : '',
    vat_number  : ''
  });
  const [modalType, setModalType] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  // Filter States
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [seriesFilter, setSeriesFilter] = useState('');
  const [subDomainFilter, setSubDomainFilter] = useState('');
  const [countryFilter, setCountryFilter] = useState('');
  const [dropdownData, setDropdownData] = useState({
       countries: [],
  }); 

  // Fetch data list
  const fetchData = useCallback(async () => {
    try {
      const data = await getData({ pdf_status: 1});
      setDataList(data);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
  }, []);

  // Fetch all dropdown data
  const fetchDropdownData = useCallback(async () => {
    try {
      const [country] = await Promise.all([
        getcountries(),            
      ]);
  
      setDropdownData({
        countries: country,
      });
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    }
  }, []);

  useEffect(() => {
    const fetchDataAsync = async () => {
      setLoading(true); 
      await fetchData();
      await fetchDropdownData();
      // Optional 2 second delay
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setLoading(false); 
    };
  
    fetchDataAsync();
  }, [fetchData, fetchDropdownData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // Inside your invoiceReceiptGenerated component
  const navigate = useNavigate();  // Initialize the useHistory hook
  
  const pdfModal = async (type, row) => {
    try {
      // Send the ID in the body of a POST request
      const data = await getDataById({ id: row.id });

      // If the data is fetched successfully, navigate to the PDF page
      if (data) {
        // Assuming you want to pass the data to another page
        navigate('/invoiceReceiptPdf', { state: { data } });  // Use navigate to go to PDF page with state
      }
    } catch (error) {
      console.error('Error fetching data by ID:', error);
    }
  };

  const openModal = (type, data = { 
    id  : '',
    bank_address  : '',
    bank_name  : '',
    beneficiarys_account_number  : '',
    beneficiarys_address  : '',
    beneficiarys_name  : '',
    billing_address  : '',
    billing_country  : '',
    billing_email  : '',
    billing_name  : '',
    billing_phone_no  : '',
    createdAt  : '',
    currency  : '',
    event_date  : '',
    event_title  : '',
    event_type  : '',
    in_branch_code  : '',
    in_iban_bic_code  : '',
    in_swift_code  : '',
    invoice_date  : '',
    invoice_id  : '',
    no_of_ticket  : '',
    payment_mode  : '',
    pdf_status  : '',
    reg_amount  : '',
    registration_type  : '',
    series  : '',
    sub_domain  : '',
    subject  : '',
    updatedAt  : '',
    us_ein_number  : '',
    us_iban_number  : '',
    us_swift_bic_code  : '',
    vat_number  : ''
  }) => {
    setModalType(type);
    setForm(data);
    setShowModal(true);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  
  const getCurrencySymbol = (currencyCode) => {
    switch (currencyCode?.toUpperCase()) {
      case 'USD': return '$';
      case 'EUR': return '€';
      case 'INR': return '₹';
      case 'GBP': return '£';
      case 'RUB': return '₽';
      case 'THB': return '฿';
      default: return currencyCode || '';
    }
  }; 

  //based country code append country name
  const getCountryName = (code) => {
  const country = dropdownData.countries.find(c => c.code === code);
  return country ? country.name : code;
  };

  //Filtered data
   const filteredData = useMemo(() => {
   const startDateObj = startDate ? new Date(startDate) : null;
   const endDateObj = endDate ? new Date(endDate) : null;
   
       return dataList
         .filter((data) => {
           const matchesText =
              data.sub_domain.toLowerCase().includes(searchText.toLowerCase()) ||
              data.billing_name.toLowerCase().includes(searchText.toLowerCase()) ||
              data.reg_amount.toString().includes(searchText.toLowerCase());
   
           const date = data.invoice_date ? new Date(data.invoice_date) : null;

           // If both startDate and endDate are provided, filter by date range
           const inRange = (startDateObj && endDateObj) 
             ? date >= startDateObj && date <= endDateObj 
             : true; // Otherwise, no date filtering
   
           // Other filters (series, subDomain, country)
           const matchSeries = !seriesFilter || data.series === seriesFilter;
           const matchSubDomain = !subDomainFilter || data.sub_domain === subDomainFilter;
           const matchCountry = !countryFilter || data.billing_country === countryFilter;
   
           return matchesText && inRange && matchSeries && matchSubDomain && matchCountry;
         }).sort((a, b) => new Date(b.invoice_date) - new Date(a.invoice_date));
   }, [dataList, searchText, seriesFilter, subDomainFilter, countryFilter, startDate, endDate]);
   

  const columns = [
    {
      name: '#',
      selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
      sortable: false,
      width: '10%',
    },
    {
      name: 'Invoice Date',
      selector: (row) => row.invoice_date,
      sortable: true,
      width: '10%',
      wrap: true
    },
    {
    name: 'Series',
    selector: (row) => {
      // Assuming the `series` field is in format like "2025-11" or "2025-11-15"
      const date = new Date(row.series);
      
      // Format as "2025-11 Nov 2025"
      const year = date.getFullYear();
      const month = date.getMonth(); // 0-based index, so we add 1
      const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ];
      
      return ` ${months[month]} ${year}`;
    },
    sortable: true,
    width: '10%',
    wrap: true
   },
    {
      name: 'Sub domain',
      selector: (row) => row.sub_domain,
      sortable: true,
      width: '15%',
      wrap: true
    },
    {
      name: 'Name',
      selector: (row) => row.billing_name,
      sortable: true,
      width: '15%',
      wrap: true
    },
    {
      name: 'Country',
      selector: (row) => getCountryName(row.billing_country),
      sortable: true,
      width: '15%',
      wrap: true
    },
    {
      name: 'Reg Amount',
      selector: (row) => {
        const currencySymbol = getCurrencySymbol(row.currency);
        return <b className='fs-4'>{currencySymbol} {row.reg_amount}</b>;
      },
      sortable: true,
      width: '15%',
      wrap: true
    },
    {
      name: 'Actions',
      cell: (row) => (
        <div>
          <Button variant="danger" size="sm" onClick={() => openModal('edit', row)} > <i className="align-middle far fa-fw fa-file-pdf"></i>PDF</Button>
        </div>
      ),
      width: '10%',
      wrap: true
    },
  ];

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        <div className=" row m-3 d-flex flex-column gap-3 ">
          <div className="d-flex gap-2">
            {/* Dropdown for Filters */}
            <div className="col-md-2">
              <span className='fs-5 text-dark'>Series</span>
              <select className="form-control" value={seriesFilter} onChange={(e) => setSeriesFilter(e.target.value)}>
                <option value="">All Series</option>
                {Array.from(new Set(dataList.map(item => item.series))).sort((a,b) => b.localeCompare(a)).map((series, idx) => (
                  <option key={idx} value={series}>{series}</option>
                ))}
              </select>
            </div>
            <div className="col-md-2">
              <span className='fs-5 text-dark'>Sub Domain</span>
              <select className="form-control" value={subDomainFilter} onChange={(e) => setSubDomainFilter(e.target.value)}>
                <option value="">All Subdomains</option>
                {Array.from(new Set(dataList.map(item => item.sub_domain))).sort((a,b) => a.localeCompare(b)).map((subDomain, idx) => (
                  <option key={idx} value={subDomain}>{subDomain}</option>
                ))}
              </select>
            </div>
            <div className="col-md-2">
            <span className='fs-5 text-dark'>Countries</span>
            <select
              className="form-control"
              value={countryFilter}
              onChange={(e) => setCountryFilter(e.target.value)}
            >
              <option value="">All Countries</option>
              {dropdownData.countries.map((country) => (
                <option key={country.code} value={country.code}>
                  {country.name}
                </option>
              ))}
            </select>
          </div>

            {/* Start Date and End Date Input */}
            <div className="col-md-2">
              <span className='fs-5 text-dark'>Start Date</span>
              <input
                type="date"
                className="form-control"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="col-md-2">
              <span className='fs-5 text-dark'>End Date</span>
              <input
                type="date"
                className="form-control"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
          </div> 
        </div>
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center w-100"
            style={{ minHeight: "300px" }}
          >
            <Spinner/>
          </div>
                  ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className='fs-4 text-dark'>PDF Generation / Invoice Receipt / Invoice Generated Receipt </p>
            </div>
          </div>

          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 20, 50, 100, 200, 500]}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
            }
          />

          {/* Modal for Add/Edit data */}
          <Modal className="modal-lg" backdrop="static" show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label className='fs-5 text-dark'>Invoice Id</Form.Label> <small className='fs-5 text-danger'>*</small>
                  <Form.Control type="text" name="invoice_id" value={form.invoice_id} onChange={handleChange} required/>
                </Form.Group>
              </Form>
              <Table striped bordered hover responsive className="table-sm">
                <thead>
                  <tr>
                    <th className='bg-secondary text-white' colSpan={2}>Invoice Details </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Invoice Id</td>
                    <td>{form.invoice_id}</td>
                  </tr>
                  <tr>
                    <td>Invoice Date</td>
                    <td>{form.invoice_date}</td>
                  </tr>
                  <tr>
                    <td>Registration Type</td>
                    <td>{form.registration_type}</td>
                  </tr>
                  <tr>
                    <td>Registration Amount</td>
                    <td>{form.reg_amount}</td>
                  </tr>
                  <tr>
                    <td>Number of Ticket</td>
                    <td>{form.no_of_ticket}</td>
                  </tr>
                  <tr>
                    <td>Currency</td>
                    <td>{form.currency}</td>
                  </tr>
                  <tr>
                    <td>Payment Mode</td>
                    <td>{form.payment_mode}</td>
                  </tr>
                </tbody>
                <br></br>
                <thead>
                  <tr>
                    <th className='bg-secondary text-white' colSpan={2}>Billing Address</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Name</td>
                    <td>{form.billing_name}</td>
                  </tr>
                  <tr>
                    <td>Email</td>
                    <td>{form.billing_email}</td>
                  </tr>
                  <tr>
                    <td>Phone Number</td>
                    <td>{form.billing_phone_no}</td>
                  </tr>
                  <tr>
                    <td>Address</td>
                    <td>{form.billing_address}</td>
                  </tr>
                  <tr>
                    <td>Country</td>
                    <td>{getCountryName(form.billing_country)}</td>
                  </tr>
                </tbody>
                <br></br>
                <thead>
                  <tr>
                    <th className='bg-secondary text-white' colSpan={2}>Bank Details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Beneficiarys Name</td>
                    <td>{form.beneficiarys_name}</td>
                  </tr>
                  <tr>
                    <td>Beneficiarys Address</td>
                    <td>{form.beneficiarys_address}</td>
                  </tr>
                  <tr>
                    <td>Bank Name</td>
                    <td>{form.bank_name}</td>
                  </tr>
                  <tr>
                    <td>Bank Address</td>
                    <td>{form.bank_address}</td>
                  </tr>
                  <tr>
                    <td>Beneficiarys Acc No</td>
                    <td>{form.beneficiarys_account_number}</td>
                  </tr>   

                  {form.in_swift_code && (
                    <tr>
                      <td>SWIFT Code</td>
                      <td> {form.in_swift_code}</td>
                    </tr>
                  )}

                  {form.in_branch_code && (
                    <tr>
                      <td>Branch Code</td>
                      <td> {form.in_branch_code}</td>
                    </tr>
                  )}

                  {form.in_iban_bic_code && (
                  <tr>
                  <td>IBAN and BIC</td>
                  <td> {form.in_iban_bic_code}</td>
                  </tr>
                  )}

                  {form.us_swift_bic_code && (
                  <tr>
                  <td>SWIFT / BIC Code</td>
                  <td> {form.us_swift_bic_code}</td>
                  </tr>
                  )}

                  {form.us_iban_number && (
                  <tr>
                  <td>IBAN Number</td>
                  <td> {form.us_iban_number}</td>
                  </tr>
                  )}

                  {form.us_ein_number && (
                  <tr>
                  <td>EIN</td>
                  <td> {form.us_ein_number}</td>
                  </tr>
                  )}
                </tbody>
              </Table>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}> Cancel </Button>
              <Button variant="primary" onClick={() => pdfModal('edit', form)}> Generate PDF </Button>
            </Modal.Footer>
          </Modal>

        </div>
        <Footer />
        </div>
        )};
      </div>
    </div>
  );
};

export default InvoiceReceiptGenerated;
